import {
  endOfDay,
  format, parse, parseISO, startOfDay,
} from 'date-fns';
import { pad2 } from './generalUtils';

export function formUtcStringFromDate(dateValue: Date): string {
  if (dateValue) {
    return `${dateValue.getFullYear()}-${(dateValue.getMonth() + 1).toString().padStart(2, '0')}-${dateValue.getDate().toString().padStart(2, '0')}T00:00:00.000Z`;
  }
  return null;
}

export function parseDatefromString(dateString: string): Date {
  return dateString ? parseISO(dateString) : null;
}

export function parseMidnightDatefromString(dateString: string): Date {
  return dateString ? new Date(parseISO(dateString).setHours(0, 0, 0, 0)) : null;
}

export function parseStringFromDate(date: Date): string {
  return date ? format(date, 'MM-dd-yyyy') : '';
}

export function parseAbbreviatedDateString(dateString: string): Date {
  return dateString ? parse(dateString, 'MMM d, yyyy', new Date()) : null;
}

export function parseAbbreviatedStringFromDate(date: Date): string {
  return date ? format(date, 'MMM d, yyyy') : '';
}

export function setEndOfDay(date: Date): Date {
  return date ? endOfDay(date) : null;
}

export function setStartOfDay(date: Date): Date {
  return date ? startOfDay(date) : null;
}

export function parseUTCStringStartOfDay(date: Date | string): string {
  const isDate = typeof date === 'string' ? new Date(date) : date;

  const monthValue = isDate.getMonth() + 1;
  const dayValue = isDate.getDate();
  return isDate ? `${isDate.getFullYear()}-${pad2(monthValue)}-${pad2(dayValue)}T00:00:00Z` : ''; // 2020-01-01T00:00:00Z
}

export function parseUTCStringEndOfDay(date: Date | string): string {
  const isDate = typeof date === 'string' ? new Date(date) : date;

  const monthValue = isDate.getMonth() + 1;
  const dayValue = isDate.getDate();
  return isDate ? `${isDate.getFullYear()}-${pad2(monthValue)}-${pad2(dayValue)}T23:59:59.999Z` : ''; // 2020-01-01T23:59:59.999Z
}

export const getCurrentYear = new Date().getFullYear();
